import { observer } from "mobx-react-lite"
import { UploadStatus } from "./FileUploadStore"
import { useTheme } from "theme/useTheme"
import UploadIcon from "@mui/icons-material/UploadFile"
import DoneIcon from "@mui/icons-material/DownloadDone"
import FailedIcon from "@mui/icons-material/PriorityHigh"
import Avatar, { AvatarProps } from "@mui/material/Avatar"

export default observer(function FileUploadAvatar({ status, ...avatarProps }: React.PropsWithChildren<UploadIconProps & AvatarProps>) {
   const theme = useTheme()

   const Icon = (() => {
      switch (status) {
         case UploadStatus.valid: return DoneIcon
         case UploadStatus.failed:
         case UploadStatus.invalid:
            return FailedIcon
         default: return UploadIcon
      }
   })()

   return (
      <Avatar {...avatarProps} sx={{
         ...avatarProps.sx,
         backgroundColor: '#3314351F',
      }}>
         <Icon
            color="primary"
            sx={{ width: theme.spacing(3) }}
         />
      </Avatar>
   )
})

interface UploadIconProps {
   status?: UploadStatus
}